import Swal from 'sweetalert2';

export const SweetAlert = {
  // Confirm Dialog
  confirm: (options = {}) => {
    const {
      title = 'Are you sure?',
      text = 'This action cannot be undone!',
      confirmButtonText = 'Yes',
      cancelButtonText = 'Cancel',
      confirmButtonColor = '#d33',
      cancelButtonColor = '#3085d6',
      icon = 'warning',
      showCancelButton = true,
      ...rest
    } = options;

    return Swal.fire({
      title,
      text,
      icon,
      showCancelButton,
      confirmButtonColor,
      cancelButtonColor,
      confirmButtonText,
      cancelButtonText,
      reverseButtons: true,
      ...rest
    });
  },

  // Success Alert
  success: (options = {}) => {
    const {
      title = 'Success!',
      text = '',
      timer = 2000,
      showConfirmButton = false,
      ...rest
    } = options;

    return Swal.fire({
      title,
      text,
      icon: 'success',
      timer,
      showConfirmButton,
      ...rest
    });
  },

  // Error Alert
  error: (options = {}) => {
    const {
      title = 'Error!',
      text = 'Something went wrong!',
      confirmButtonText = 'OK',
      ...rest
    } = options;

    return Swal.fire({
      title,
      text,
      icon: 'error',
      confirmButtonText,
      ...rest
    });
  },

  // Warning Alert
  warning: (options = {}) => {
    const {
      title = 'Warning!',
      text = '',
      confirmButtonText = 'OK',
      ...rest
    } = options;

    return Swal.fire({
      title,
      text,
      icon: 'warning',
      confirmButtonText,
      ...rest
    });
  },

  // Info Alert
  info: (options = {}) => {
    const {
      title = 'Information',
      text = '',
      confirmButtonText = 'OK',
      ...rest
    } = options;

    return Swal.fire({
      title,
      text,
      icon: 'info',
      confirmButtonText,
      ...rest
    });
  },

  // Delete Confirmation (Specialized for delete operations)
  deleteConfirm: (itemName = 'this item') => {
    return Swal.fire({
      title: 'Are you sure?',
      text: `You are about to delete ${itemName}. This action cannot be undone!`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    });
  }
};

export default SweetAlert;